import Configuration from '../configuration.model'

export default {
  get: ({ GET }, id) =>
    new Promise((resolve, reject) => {
      return GET(`production/configurations/${id}`)
        .then(reponse => {
          const data = reponse.data
          if (reponse.status === 200 && data.id) {
            const model = new Configuration(data)
            resolve(model)
          } else {
            reject(reponse.status)
          }
        })
        .catch(error => {
          reject(error)
        })
    }),
  list: ({ GET }, data) =>
    new Promise((resolve, reject) => {
      return GET(`production/configurations`, { ...data })
        .then(reponse => {
          const data = reponse.data
          if (reponse.status === 200 && data) {
            let models = []
            data.forEach(modelData => {
              models.push(new Configuration(modelData))
            })
            resolve(models)
          } else {
            reject(reponse.status)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
}
